export default __webpack_public_path__ + "static/11_35-cdad960c0c9d90cf8b978fe9f790fe49.png";